import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useLoading } from '../../contexts/LoadingContext';

import { useGetUserActivities } from '../../hooks/db/useGetUserActivities';
import { formatDateTime } from '../../lib/common';
import { useSearchParams } from 'react-router-dom';
import PaginationControls from '../PaginationControls/PaginationControls';

const Activities: React.FC = () => {
    const { getUserActivities } = useGetUserActivities()
    const [activities, setActivities] = useState<Record<string, any>[]>([])
    const { setLoading } = useLoading()

    const [totalCount, setTotalCount] = useState(0)
    const pageSize = parseInt(process.env.REACT_APP_PAGE_SIZE || '10', 10)

    const [searchParams, setSearchParams] = useSearchParams()
    const initialPage = parseInt(searchParams.get('page') || '1', 10)
    const [currentPage, setCurrentPage] = useState(initialPage)

    const fetchActivities = async (page: number) => {
        setLoading(true)
        try {
            let filters = {}
            const result = await getUserActivities(page, pageSize, filters)
            if (result && 'activities' in result) {
                setActivities((result as { activities: any }).activities)
                setTotalCount(result.totalCount)
            }
        } catch (error) {
            if ((error as Error).name === 'AbortError') {
                console.log("Fetch aborted");
            } else {
                console.error("Error fetching activities:", error);
            }
                toast.error("Error fetching activities", {
                position: "bottom-center",
                })
        }finally{
            setLoading(false)
        }
    }

    const showActivityDetails = (row: any) => {
        if(row.activity && row.activity === 'QUERY' && row.details){
            return row.details?.text || ''
        }
    }

    useEffect(() => {
        fetchActivities(currentPage)
    }, [currentPage])

    return (
        <div className="flex flex-col md:flex-row h-[80vh] overflow-hidden">
        {/* Left panel - Table */}
        
            <div className={`overflow-auto w-full `}>
                <div className="flex justify-between items-center p-4">
                    <h2 className="text-xl font-bold">User Activities</h2>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full table-auto rounded-lg border text-sm text-left">
                    <thead className="bg-gray-200">
                        <tr>
                        <th className="px-4 py-2 border-b text-gray-700">Activity</th>
                        <th className="px-4 py-2 border-b text-gray-700">User</th>
                        <th className="px-4 py-2 border-b text-gray-700">Details</th>
                        <th className="px-4 py-2 border-b text-gray-700">Created At</th>
                        </tr>
                    </thead>
                    <tbody>
                        {activities.map((row, index) => (
                        <tr
                            key={index}
                            className={''}
                        >
                            <td
                            className="px-4 py-2 border-b"
                            width="10%"
                            >
                            {row.activity || 'No Title'}
                            </td>
                            <td className="px-4 py-2 border-b" width="15%">{row.user?.name || 'N/A'}</td>
                            <td className="px-4 py-2 border-b" width="50%">{showActivityDetails(row)}</td>
                            <td className="px-4 py-2 border-b" width="15%">
                                {formatDateTime(row.createdAt)}
                            </td>
                        </tr>
                        ))}
                    </tbody>
                    </table>
                </div>
                <PaginationControls
                    currentPage={currentPage}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    onPageChange={(newPage) => {
                        setCurrentPage(newPage)
                        setSearchParams({ page: newPage.toString() })
                    }}
                />
            </div>
        </div>

      )
      
}

export default Activities